<template>
  <div class="view-admin-home">
    <div class="column">
      <router-link :to="{ name: 'admin-users-list' }"> Nutzer </router-link>
      <router-link :to="{ name: 'admin-organizations-list' }">
        Organisationen
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss">
.view-admin-home {
  width: 100%;
  padding: 2rem;
}
</style>
